// Ban CMS (id build) cua tab va cua may chu. Mot tab mo tu truoc lan deploy van chay code cu tren API moi:
// 2026-09-29 hop tien cu doc approveAboveVnd (API moi da bo) -> BigInt(undefined) -> ca trang trang.
// Tab hoi /version.json (vite.config.ts ghi cung id voi __CMS_BUILD__) moi lan chuyen trang va khi mot trang
// loi; may chu da co ban khac thi tai lai trang (ban moi).

declare const __CMS_BUILD__: string | undefined;
export const BAN_NAY: string = typeof __CMS_BUILD__ === 'string' ? __CMS_BUILD__ : 'dev';

// Ban may chu (id) khi khac ban tab, null khi giong hoac khong doc duoc (loi mang, file la): khong ket luan.
export function banMoi(json: unknown, banNay: string = BAN_NAY): string | null {
  const b = json && typeof json === 'object' ? (json as { build?: unknown }).build : undefined;
  return typeof b === 'string' && b !== '' && b !== banNay ? b : null;
}

type KhoLuu = { getItem(k: string): string | null; setItem(k: string, v: string): void };
const KHOA = 'cms-da-tai-lai-cho-ban';

// Tai lai toi da mot lan cho moi ban may chu trong phien tab: may chu tra ban khac ma tai lai van la ban cu
// (cache, deploy do dang) thi dung, khong tai lai mai.
export function nenTaiLai(moi: string | null, kho: KhoLuu): boolean {
  if (!moi || kho.getItem(KHOA) === moi) return false;
  kho.setItem(KHOA, moi);
  return true;
}

let dangHoi: Promise<boolean> | null = null;

// Hoi may chu; ban khac thi tai lai trang. Tra ve true khi dang tai lai.
export function kiemBan(): Promise<boolean> {
  dangHoi ??= (async () => {
    try {
      const r = await fetch('/version.json?t=' + Date.now(), { cache: 'no-store', credentials: 'same-origin' });
      if (!r.ok || !nenTaiLai(banMoi(await r.json()), sessionStorage)) return false;
      location.reload();
      return true;
    } catch {
      return false; // mang loi: hoi lai lan sau
    } finally {
      dangHoi = null;
    }
  })();
  return dangHoi;
}
